import script from "./ToTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToTop.vue?vue&type=script&lang=ts&setup=true"

import "./ToTop.vue?vue&type=style&index=0&id=c03a8c7a&lang=scss"

const __exports__ = script;

export default __exports__